import React from 'react';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { WizardSummary, getTaskDetailRow } from 'sellDirect/components/closingDash/WizardSummary';
import { text } from 'sellDirect/components/closingDash/content';

export interface ServiceProvidersSummaryProps {
  shouldSeeAgentExperience: boolean;
  closingTasks: ClosingTasks;
  setIsEditingForm: (isEditingForm: boolean) => void;
}

/**
 * Renders WizardSummary for service providers form.
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const ServiceProvidersSummary: React.FC<ServiceProvidersSummaryProps> = ({
  shouldSeeAgentExperience,
  closingTasks,
  setIsEditingForm,
}) => {
  const serviceAccounts = closingTasks.serviceAccounts?.taskable;
  const otherServicesInfo = closingTasks?.otherHomeInfo?.taskable;

  const utilitiesRows = [
    getTaskDetailRow(
      text.disclosuresPage.serviceAccounts.waterProvider(shouldSeeAgentExperience),
      serviceAccounts?.water,
    ),
    getTaskDetailRow(
      text.disclosuresPage.serviceAccounts.electricalProvider(shouldSeeAgentExperience),
      serviceAccounts?.electricity,
    ),
    getTaskDetailRow(
      text.disclosuresPage.serviceAccounts.hasGas(shouldSeeAgentExperience),
      !!serviceAccounts?.gas,
    ),
  ];
  if (serviceAccounts?.gas) {
    utilitiesRows.push(
      getTaskDetailRow(
        text.disclosuresPage.serviceAccounts.gasProvider(shouldSeeAgentExperience),
        serviceAccounts?.gas,
      ),
    );
  }

  const otherServicesRows = [
    getTaskDetailRow(
      text.disclosuresPage.otherHomeInfo.trashCollectionInfo(shouldSeeAgentExperience),
      otherServicesInfo?.trashCollection,
    ),
    getTaskDetailRow(
      text.disclosuresPage.otherHomeInfo.recyclingCollectionInfo(shouldSeeAgentExperience),
      otherServicesInfo?.recyclingCollection,
    ),
    getTaskDetailRow(
      text.disclosuresPage.otherHomeInfo.mailDetails(shouldSeeAgentExperience),
      otherServicesInfo?.mailboxNumber,
    ),
  ];

  if (otherServicesInfo?.additionalInfo && otherServicesInfo?.additionalInfo !== ' ') {
    otherServicesRows.push(
      getTaskDetailRow(
        text.disclosuresPage.otherHomeInfo.additionalHomeInformation(shouldSeeAgentExperience),
        otherServicesInfo?.additionalInfo,
      ),
    );
  }

  return (
    <WizardSummary
      rows={[...utilitiesRows, ...otherServicesRows]}
      trackingName="service-providers-form"
      onEdit={() => setIsEditingForm(true)}
      disableEdit={false}
    />
  );
};
